// For now TPS admin is the only user persona will access this portal
// If any other persona`s added, please add neccesary roles here
export enum RoleType {
  TPS_ADMIN = "TPS_ADMIN",
  NONE = "none",
}

export type UserMetadata = {
  alias: string;
  role: RoleType;
  email?: string;
};

export const testUser1: UserMetadata = {
  alias: "testUser1",
  role: RoleType.TPS_ADMIN,
  email: "testUser1@amazon.com",
};

export const testUser2: UserMetadata = {
  alias: "testUser2",
  role: RoleType.NONE,
  email: "testUser2@amazon.com",
};
